export const EMPTY_ITEM = 'empty';
export const ADD_ITEM = 'add';
export const DRAG_ITEM = 'drag';
export const GAP_ITEM = 'gap';

export const ADD_ENTRY_BUTTON_HEIGHT = 38;
export const ADD_FIELD_BUTTON_COLUMN_WIDTH = 40;
export const QUICK_CALC_ROW_HEIGHT = 48;
export const COMPACT_QUICK_CALC_ROW_HEIGHT = 44;
export const STICKY_BOTTOM_ELEMENTS_HEIGHT =
  ADD_ENTRY_BUTTON_HEIGHT + QUICK_CALC_ROW_HEIGHT;
